// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__3Mwyv","tagSm":"Tag_tagSm__2LBpZ","tagMd":"Tag_tagMd__W6ZOv","tagLg":"Tag_tagLg__1rsyE"};